module.exports = __webpack_public_path__ + "static/media/home.2bd69eb7.svg";